(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tiktok-bridge"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const trackingKeys = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term', 'utm_id', 'ttclid'];
    const tikTokPattern = /musical_ly|TikTok|Bytedance|ByteLocale|com\.ss\.android\.ugc\.trill|com\.zhiliaoapp\.musically/i;

    const buildDestination = (rawDestination) => {
      const target = new URL(rawDestination || '/', window.location.origin);
      const incoming = new URLSearchParams(window.location.search);

      if (!target.searchParams.has('utm_source')) target.searchParams.set('utm_source', 'tiktok');
      if (!target.searchParams.has('utm_medium')) target.searchParams.set('utm_medium', 'social');
      if (!target.searchParams.has('utm_campaign')) target.searchParams.set('utm_campaign', 'bio');
      if (!target.searchParams.has('utm_content')) target.searchParams.set('utm_content', 'bridge');

      trackingKeys.forEach((key) => {
        const value = incoming.get(key);
        if (value) target.searchParams.set(key, value);
      });

      return target.toString();
    };

    const ensureRescueToken = () => {
      const current = new URL(window.location.href);
      if (!current.searchParams.has('tt_rescue')) {
        const token = window.crypto && typeof window.crypto.randomUUID === 'function'
          ? window.crypto.randomUUID()
          : `tt_${Date.now().toString(36)}_${Math.random().toString(36).slice(2, 10)}`;
        current.searchParams.set('tt_rescue', token);
        window.history.replaceState(window.history.state, document.title, current.toString());
      }
    };

    const initializeBridge = (root) => {
      if (!root || root.dataset.initialized === 'true') return;
      root.dataset.initialized = 'true';

      const userAgent = navigator.userAgent || '';
      const query = new URLSearchParams(window.location.search);
      const forceTikTokPreview = query.get('force_tiktok') === '1';
      const isTikTok = tikTokPattern.test(userAgent) || forceTikTokPreview;
      const isIOS = /iPad|iPhone|iPod/i.test(userAgent);
      const tiktokPanel = root.querySelector('[data-tiktok-panel]');
      const browserPanel = root.querySelector('[data-browser-panel]');
      const deviceMessage = root.querySelector('[data-device-message]');
      const storeLink = root.querySelector('[data-store-link]');
      const destination = buildDestination(root.dataset.destination);

      if (isTikTok) {
        if (deviceMessage) {
          deviceMessage.textContent = isIOS ? root.dataset.iosMessage : root.dataset.androidMessage;
        }
        if (tiktokPanel) tiktokPanel.hidden = false;
        ensureRescueToken();
        root.dataset.mode = 'tiktok';
        return;
      }

      if (browserPanel) browserPanel.hidden = false;
      if (storeLink) storeLink.href = destination;
      root.dataset.mode = 'browser';

      const designMode = window.Shopify && window.Shopify.designMode;
      const shouldRedirect = root.dataset.autoRedirect === 'true' && !designMode;
      const delay = Number.parseInt(root.dataset.delay, 10);

      if (shouldRedirect) {
        window.setTimeout(() => {
          window.location.replace(destination);
        }, Number.isFinite(delay) ? delay : 1000);
      }
    };

    const initializeAll = (scope = document) => {
      scope.querySelectorAll('[data-mervira-tiktok-bridge]').forEach(initializeBridge);
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => initializeAll(), { once: true });
    } else {
      initializeAll();
    }

    document.addEventListener('shopify:section:load', (event) => initializeAll(event.target));
  })();

  } catch(e) { console.error(e); }
})();
})();
